import * as Types from '../../../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SuppliedAccessoriesDataQueryVariables = Types.Exact<{
  skus: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type SuppliedAccessoriesDataQuery = { __typename?: 'query_root', accessories?: Types.Maybe<{ __typename?: 'AccessoryEntityResponseCollection', data: Array<{ __typename?: 'AccessoryEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'Accessory', sku: string, name: string, picture?: Types.Maybe<{ __typename?: 'UploadFileEntityResponse', data?: Types.Maybe<{ __typename?: 'UploadFileEntity', id?: Types.Maybe<string>, attributes?: Types.Maybe<{ __typename?: 'UploadFile', alternativeText?: Types.Maybe<string>, formats?: Types.Maybe<any> }> }> }> }> }> }> };


export const SuppliedAccessoriesDataDocument = gql`
    query suppliedAccessoriesData($skus: [String!]!) {
  accessories(filters: {sku: {in: $skus}}) {
    data {
      id
      attributes {
        sku
        name
        picture {
          data {
            id
            attributes {
              alternativeText
              formats
            }
          }
        }
      }
    }
  }
}
    `;
export function useSuppliedAccessoriesDataQuery(baseOptions: Apollo.QueryHookOptions<SuppliedAccessoriesDataQuery, SuppliedAccessoriesDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppliedAccessoriesDataQuery, SuppliedAccessoriesDataQueryVariables>(SuppliedAccessoriesDataDocument, options);
      }
export function useSuppliedAccessoriesDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppliedAccessoriesDataQuery, SuppliedAccessoriesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppliedAccessoriesDataQuery, SuppliedAccessoriesDataQueryVariables>(SuppliedAccessoriesDataDocument, options);
        }
export type SuppliedAccessoriesDataQueryHookResult = ReturnType<typeof useSuppliedAccessoriesDataQuery>;
export type SuppliedAccessoriesDataLazyQueryHookResult = ReturnType<typeof useSuppliedAccessoriesDataLazyQuery>;
export type SuppliedAccessoriesDataQueryResult = Apollo.QueryResult<SuppliedAccessoriesDataQuery, SuppliedAccessoriesDataQueryVariables>;